import { Navigate, Route, Routes } from 'react-router-dom'
import AopsCaseDetailPage from '../../pages/aopsCase/AopsCaseDetailPage'
import MyHrManagePage from '../../pages/aopsHumanResource/myHrManage/MyHrManagePage'
import OrgChartPage from '../../pages/aopsHumanResource/orgChart/OrgChartPage'
import AppPushSendPage from '../../pages/appPush/AppPushSendPage'
import AppPushTemplateDetailPage from '../../pages/appPush/AppPushTemplateDetailPage'
import AppPushTemplateListPage from '../../pages/appPush/AppPushTemplateListPage'
import AppPushTemplateRegisterPage from '../../pages/appPush/AppPushTemplateRegisterPage'
import BannerListPage from '../../pages/banner/BannerListPage'
import BannerRegisterPage from '../../pages/banner/BannerRegisterPage'
import BannerUpdatePage from '../../pages/banner/BannerUpdatePage'
import CommunityCommentPage from '../../pages/community/CommunityCommentPage'
import CommunityListPage from '../../pages/community/CommunityListPage'
import CommunityUpdatePage from '../../pages/community/CommunityUpdatePage'
import CommunityUserListPage from '../../pages/community/CommunityUserListPage'
import CrmHistoryPage from '../../pages/customer/CrmHistoryPage'
import CustomerCouponAndPointManagePage from '../../pages/customer/CustomerCouponAndPointManagePage'
import CustomerListPage from '../../pages/customer/CustomerListPage'
import KakaoHistoryDetailPage from '../../pages/customer/KakaoHistoryDetailPage'
import KakaoHistoryPage from '../../pages/customer/KakaoHistoryPage'
import SendSmsPage from '../../pages/customer/SendSmsPage'
import DelegatedClaimsDetailPage from '../../pages/delegationClaims/DelegatedClaimsDetailPage'
import DelegatedClaimsPage from '../../pages/delegationClaims/DelegatedClaimsPage'
import PrescriptionsPage from '../../pages/delegationClaims/PrescriptionsPage'
import ElectricApprovalPage from '../../pages/electricApproval/ElectricApprovalPage'
import EventAuthListPage from '../../pages/event/EventAuthListPage'
import EventSnsEditPage from '../../pages/event/EventSnsEditPage'
import EventSnsPage from '../../pages/event/EventSnsPage'
import HomePage from '../../pages/home/HomePage'
import InquiryListPage from '../../pages/inquiry/InquiryListPage'
import ReviewListPage from '../../pages/inquiry/ReviewListPage'
import ManageOnOffPage from '../../pages/manage/ManageOnOffPage'
import MealDetailPage from '../../pages/meal/MealDetailPage'
import MealListPage from '../../pages/meal/MealListPage'
import MealRegisterPage from '../../pages/meal/MealRegisterPage'
import MealRequestListPage from '../../pages/meal/MealRequestListPage'
import BrandListPage from '../../pages/product/BrandListPage'
import ProductListPage from '../../pages/product/ProductListPage'
import ProductRegisterPage from '../../pages/product/ProductRegisterPage'
import ProgramDetailPage from '../../pages/program/ProgramDetailPage'
import ProgramManagePage from '../../pages/program/ProgramManagePage'
import ProgramRegisterPage from '../../pages/program/ProgramRegisterPage'
import CouponCreatePage from '../../pages/promotion/CouponCreatePage'
import CouponListPage from '../../pages/promotion/CouponListPage'
import OrderCancelPage from '../../pages/sales/OrderCancelPage'
import OrderCompletePage from '../../pages/sales/OrderCompletePage'
import OrderConfirmPage from '../../pages/sales/OrderConfirmPage'
import OrderDeliveryPage from '../../pages/sales/OrderDeliveryPage'
import OrderReturnPage from '../../pages/sales/OrderReturnPage'
import OrderSearchListPage from '../../pages/sales/OrderSearchListPage'
import OrderTelPage from '../../pages/sales/OrderTelPage'
import SchedulePage from '../../pages/schedule/SchedulePage'
import StandaloneSchedulePage from '../../pages/standaloneSchedule/StandaloneSchedulePage'
import InflowStatisticsPage from '../../pages/statistics/InflowStatisticsPage'
import SalesStatisticsPage from '../../pages/statistics/SalesStatisticsPage'
import AddAopsMember from '../apos/AddAopsMember'

import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { getUserRole, getUserTeam } from '../../api/aops.api'
import ScheduleVisionBoardPage from '../../pages/standaloneSchedule/ScheduleVisionBoardPage'
import StandaloneAdminSchedulePage from '../../pages/standaloneSchedule/StandaloneAdminSchedulePage'
import VacationAdminPage from '../../pages/vacatoin/VacationAdminPage'
import VacationPage from '../../pages/vacatoin/VacationPage'
import { isAopsChiefState } from '../../store/aops'
import { userState } from '../../store/user'
const PageRouting = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [user] = useRecoilState(userState)
  const [isChief] = useRecoilState(isAopsChiefState)

  useEffect(() => {
    const fetchUserRole = async () => {
      const res = await getUserRole(user?.id)
      return res
    }
    fetchUserRole().then((res) => {
      if (location.pathname === '/' && res === 'employee') {
        const fetchTeamAndRedirect = async () => {
          try {
            // 2. API를 호출하여 팀 정보를 가져옵니다.
            const res = await getUserTeam(user?.id)
            // console.log('res::', res.data)
            const teamName = res.data === 'all' ? 'planning' : res.data

            if (teamName) {
              sessionStorage.setItem('hasRedirectedToSchedule', 'true')
              // 3. 받아온 team 정보를 이용해 스케줄 페이지로 이동
              // replace: true를 설정하면 뒤로가기 시 다시 '/'로 오는 것을 방지합니다.
              navigate(`/schedule/${teamName}`, { replace: true })
            }
          } catch (error) {
            console.error('팀 정보를 불러오는 데 실패했습니다.', error)
          }
        }

        fetchTeamAndRedirect()
      }
    })
  }, [location.pathname, navigate, user.id])

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/*회원 관리*/}
      <Route path="/customer/list" element={<CustomerListPage />} />
      <Route path="/customer/send/sms" element={<SendSmsPage />} />
      <Route path="/customer/crm-history" element={<CrmHistoryPage />} />

      {/*문의/리뷰관리*/}
      <Route path="/inquiry/list" element={<InquiryListPage />} />
      {/* <Route path="/inquiry/product" element={<ProductInquiryListPage />} /> */}
      <Route path="/review/list" element={<ReviewListPage />} />
      {/*상품 관리*/}
      <Route path="/product/list" element={<ProductListPage />} />
      <Route
        path="/product/register/:productId"
        element={<ProductRegisterPage />}
      />
      <Route path="/product/register" element={<ProductRegisterPage />} />
      <Route path="/product-brand/list" element={<BrandListPage />} />
      {/*판매 관리*/}
      <Route path="/order/search" element={<OrderSearchListPage />} />
      <Route path="/order/tel" element={<OrderTelPage />} />
      <Route path="/order/confirm" element={<OrderConfirmPage />} />
      {/* <Route path="/order/gift" element={<OrderGiftPage />} /> */}
      <Route path="/order/delivery" element={<OrderDeliveryPage />} />
      <Route path="/order/complete" element={<OrderCompletePage />} />
      <Route path="/order/cancel" element={<OrderCancelPage />} />
      <Route path="/order/return" element={<OrderReturnPage />} />
      {/*통계 관리*/}
      <Route path="/statistics/sales" element={<SalesStatisticsPage />} />
      <Route path="/statistics/inflow" element={<InflowStatisticsPage />} />
      {/*프로모션 관리*/}
      <Route path="/coupon/list" element={<CouponListPage />} />
      <Route path="/coupon/register/:couponId" element={<CouponCreatePage />} />
      <Route path="/coupon/register" element={<CouponCreatePage />} />
      {/*프로그램 관리*/}
      <Route path="/program/manage" element={<ProgramManagePage />} />
      <Route path="/program/create" element={<ProgramRegisterPage />} />
      <Route
        path="/program/detail/:programId"
        element={<ProgramDetailPage />}
      />

      {/* 음식, 식단 관리 */}
      <Route path="/meals/create" element={<MealRegisterPage />} />
      {/* <Route path="/meal/category-create" element={<MealCategoryRegisterPage />} /> */}
      <Route path="/meals/request-manage" element={<MealRequestListPage />} />
      <Route path="/meals/manage" element={<MealListPage />} />
      <Route path="/meals/:mealId" element={<MealDetailPage />} />

      {/* 이벤트 관리 */}
      <Route path="/event/auth/list" element={<EventAuthListPage />} />
      <Route path="/event/sns/list" element={<EventSnsPage />} />
      <Route path="/event/sns/edit/:eventId" element={<EventSnsEditPage />} />
      {/* <Route path="/meal/manage" element={<MealManagePage />} /> */}

      {/* 앱푸시 관리 */}
      <Route path="/appPush/send" element={<AppPushSendPage />} />
      <Route path="/appPush/templates" element={<AppPushTemplateListPage />} />
      <Route
        path="/appPush/templates/register"
        element={<AppPushTemplateRegisterPage />}
      />
      <Route
        path="/appPush/templates/:templateId"
        element={<AppPushTemplateDetailPage />}
      />

      {/* 배너 관리 */}
      <Route path="/banner/list" element={<BannerListPage />} />
      <Route path="/banner/update/:bannerId" element={<BannerUpdatePage />} />
      <Route path="/banner/register" element={<BannerRegisterPage />} />
      {/* 쿠폰, 포인트 발급 */}
      <Route
        path="/customer/reward-manage"
        element={<CustomerCouponAndPointManagePage />}
      />
      {/* 카카오 알림톡 내역 임시 페이지 */}
      <Route path="/customer/kakao-history" element={<KakaoHistoryPage />} />
      <Route
        path="/customer/kakao-history/:campaignId"
        element={<KakaoHistoryDetailPage />}
      />
      {/* 관리 ON/OFF 페이지 */}
      <Route path="/manage/setting" element={<ManageOnOffPage />} />

      {/* 커뮤니티 관리 */}
      <Route path="/community/user/list" element={<CommunityUserListPage />} />
      <Route path="/community/list" element={<CommunityListPage />} />
      <Route
        path="/community/comment/:categoryId"
        element={<CommunityCommentPage />}
      />
      <Route
        path="/community/update/:categoryId/:communityId"
        element={<CommunityUpdatePage />}
      />

      {/* 위임청구 관련 */}
      <Route path="/delegated-claims" element={<DelegatedClaimsPage />} />
      <Route
        path="/delegated-claims/:delegationId"
        element={<DelegatedClaimsDetailPage />}
      />
      <Route
        path="/delegated-claims/prescriptions"
        element={<PrescriptionsPage />}
      />

      <Route path="*" element={<Navigate to={'/'} replace />} />

      {/* 일정 관리 (추가된 부분) */}
      <Route path="/schedule/:team" element={<SchedulePage />} />
      {/* 전자 결재 */}
      <Route
        path="/electric-approval/:level"
        element={<ElectricApprovalPage />}
      />
      <Route path="/add-aops-member" element={<AddAopsMember />} />
      <Route
        path="/standalone-admin-schedule/:studio"
        element={<ScheduleVisionBoardPage />}
      />
      <Route
        path="/standalone-admin-schedule/:studio/:team"
        element={<StandaloneAdminSchedulePage />}
      />
      <Route
        path="/standalone-schedule/:studio/:team/:id"
        element={<StandaloneSchedulePage />}
      />
      <Route path="/case/:caseId" element={<AopsCaseDetailPage />} />

      {/* 인사 관리 */}
      {isChief ? (
        <>
          <Route path="/hr/org-chart" element={<OrgChartPage />} />
          <Route path="/hr/annual-leave" element={<VacationAdminPage />} />
        </>
      ) : (
        <>
          {/* 일반 직원: 내 인사관리만 노출 */}
          <Route path="/hr/my-hr-manage" element={<MyHrManagePage />} />
        </>
      )}
      <Route path="/hr/annual-leave/:userId" element={<VacationPage />} />
    </Routes>
  )
}

export default PageRouting
